import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import moment from 'moment-timezone';

@Component({
    selector: 'pk-web-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    standalone: false
})
export class FooterComponent implements OnInit {

	public year: number;

	constructor(private router: Router) {}

	get scheduleDemoHref(): string {
		const path = this.router.url.split(/[?#]/)[0];
		if (path === '/landing/solar' || path === '/landing/efficiency') {
			return '/se-form';
		}
		return '/hi-form';
	}

	ngOnInit(): void {
		this.year = moment().year();
	}
}
